function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 750,
  cy: 150,
  r: 145,
  stroke: "#6A4E69",
  strokeWidth: 10
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 770,
  y: 76,
  width: 30,
  height: 150,
  rx: 12,
  fill: "#6A4E69"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 700,
  y: 76,
  width: 30,
  height: 150,
  rx: 12,
  fill: "#6A4E69"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 450,
  cy: 151,
  r: 145,
  stroke: "#6A4E69",
  strokeWidth: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M521.5 149.402C523.5 150.557 523.5 153.443 521.5 154.598L418 214.354C416 215.509 413.5 214.065 413.5 211.756V92.2443C413.5 89.9348 416 88.4915 418 89.6462L521.5 149.402Z",
  fill: "#6A4E69"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M220.5 149.402C222.5 150.557 222.5 153.443 220.5 154.598L117 214.354C115 215.509 112.5 214.065 112.5 211.756L112.5 92.2443C112.5 89.9348 115 88.4915 117 89.6462L220.5 149.402Z",
  fill: "#C8C8C8"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 150,
  r: 145,
  stroke: "url(#paint0_linear)",
  strokeWidth: 10
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  begin: "0s",
  dur: "1s",
  from: "0 150 150",
  to: "360 150 150",
  repeatCount: "indefinite"
}));

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 150,
  y1: 0,
  x2: 150,
  y2: 300,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.285558,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.643663,
  stopColor: "#A77AA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83098,
  stopColor: "#D02577"
})));

function SvgLongLoadingPausePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLoadingPausePlay);
export default __webpack_public_path__ + "static/media/LONG-loading-pause-play.9b7c2ca4.svg";
export { ForwardRef as ReactComponent };